import { Box, Text } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';

type SlotDescriptionBadgeProps = {
  description: string;
  /** Optional top margin, used by the event-page selector layout. */
  mt?: BoxProps['mt'];
};

/**
 * Pill badge showing a timeslot's `slotDescription`. Shared by the event-page
 * TimeslotSelector and the checkout ticket summaries so the styling stays in sync.
 */
export const SlotDescriptionBadge = ({ description, mt }: SlotDescriptionBadgeProps) => (
  <Box
    display='inline-block'
    mt={mt}
    px={2}
    py='2px'
    borderRadius='full'
    bg='#F5F4F2'
    border='1px solid #E5E7EB'
    maxW='100%'
  >
    <Text fontSize='xs' fontWeight='700' color='#1B1917' noOfLines={1}>
      {description}
    </Text>
  </Box>
);
